const OrderStrategy = {
  Shuffle: "shuffle",
  EndToEnd: "concat",
  TransposeEndToEnd: "transposeConcat",
};

export default OrderStrategy;
